import auth1 from "../assets/pictures/home/NORMAL1.jpg";
import logo from "../assets/logos/RG copy 2.png";
import { cls } from "../components/Utility";
import bride1 from "../assets/pictures/home/bride1.jpeg";
import bride2 from "../assets/pictures/home/bride2.jpeg";
import bride3 from "../assets/pictures/home/bride3.jpeg";
import bride4 from "../assets/pictures/home/bride4.jpeg";
import { useEffect, useRef, useState } from "react";
import p1 from "../assets/pictures/preweddings/pre_1.webp";
import p2 from "../assets/pictures/preweddings/pre_2.webp";
import p3 from "../assets/pictures/preweddings/pre_3.webp";
import p4 from "../assets/pictures/preweddings/pre_4.webp";
import p5 from "../assets/pictures/preweddings/pre_5.webp";
import p6 from "../assets/pictures/preweddings/pr_6.jpg";
import p7 from "../assets/pictures/preweddings/pr_7.jpg";
import p8 from "../assets/pictures/preweddings/pr8.webp";
import p9 from "../assets/pictures/preweddings/pr9.webp";
import p10 from "../assets/pictures/preweddings/pr10.webp";
import p11 from "../assets/pictures/preweddings/pr11.webp";
import p12 from "../assets/pictures/preweddings/pr12.webp";
import p13 from "../assets/pictures/preweddings/pr13.webp";
import p14 from "../assets/pictures/preweddings/pr14.webp";
import p15 from "../assets/pictures/preweddings/pre15.webp";

import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";

export default function Preweddings() {
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    e.preventDefault(); // Prevent text selection
    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const handleMouseUpOrLeave = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 1; // Adjust the multiplier for speed (lower = slower)
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  const images = [p1, p2, p3, p4, p5];
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  const delay = 3000; // 3 seconds per slide

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, delay);

    return () => resetTimeout();
  }, [currentIndex]);

  return (
    <>
      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <img src={p15} />
          </div>
          <div className="absolute inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp ">
                PRE-WEDDINGS
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          <img src={p15} className="w-full h-[500px] object-cover" />

          <div className="absolute inset-x-0 top-[420px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[20px] font-semibold tracking-widest fadeInUp ">
                PRE-WEDDINGS
              </h1>
            </div>
          </div>
        </div>
      </div>

      <p className="mt-[50px] text-center font-black font-[Headings] xl:text-[35px] tracking-wider text-[25px]">
        LET YOUR LOVE ELEVATES
      </p>
      <div className="mt-[20px] ">
        <p className="text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
          {" "}
          A pre-wedding shoot that takes your love to new heights—literally and
          emotionally. With dreamy locations, breathtaking backdrops, and
          moments filled with pure joy, we capture your bond in the most
          elevated and unforgettable way.
        </p>
        <div className="flex justify-center mb-[20px]">
          <img src={logo} className="w-[70px] h-[70px] object-contain" />
        </div>
      </div>

      {/* <img
        src={auth1}
        className=" object-cover w-full xl:h-[600px] h-full mb-[30px] "
      /> */}

      <div className={cls("hidden", "xl:flex")}>
        <div
          ref={scrollContainerRef}
          className={`fullscreen-scroll-container ${
            isDragging ? "dragging" : ""
          }`}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseUpOrLeave}
          onMouseUp={handleMouseUpOrLeave}
          onMouseMove={handleMouseMove}
        >
          <div className="scroll-item">
            <img src={p8} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={p9} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={p10} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={p11} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={p12} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={p13} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={p14} alt="Image 1" />
          </div>
        </div>
      </div>
      <div className={cls("flex mb-[10px] mt-[30px]", "xl:hidden")}>
        <div class="w-full overflow-x-auto no-scrollbar">
          <div class="flex ">
            <img src={p8} class="w-[300px] h-[400px] object-cover p-[5px] " />
            <img src={p9} class="w-[300px] h-[400px] object-cover p-[5px]" />
            <img src={p10} class="w-[300px] h-[400px] object-cover p-[5px] " />
            <img src={p11} class="w-[300px] h-[400px] object-cover p-[5px]" />
            <img src={p12} class="w-[300px] h-[400px] object-cover p-[5px] " />
            <img src={p13} class="w-[300px] h-[400px] object-cover p-[5px]" />
            <img src={p14} class="w-[300px] h-[400px] object-cover p-[5px] " />
          </div>
        </div>
      </div>

      <div
        className={cls(
          "flex flex-col justify-center items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 gap-[10px] mb-[20px] mt-[30px]"
        )}
      >
        <img
          src={p6}
          className="w-full h-[600px] object-cover xl:w-[600px] xl:h-[800px]"
        />
        <img
          src={p7}
          className="w-full h-[600px] object-cover xl:w-[600px] xl:h-[800px]"
        />
      </div>
      <div className="pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 mb-[40px] mt-[40px]">
        <div className="relative w-full xl:h-[700px] h-full overflow-hidden">
          {/* Slides */}
          <div
            className="flex transition-transform duration-1000 ease-linear h-full"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {images.map((img, index) => (
              <div
                key={index}
                className="w-full xl:h-[700px] h-full flex-shrink-0"
              >
                <img
                  src={img}
                  alt={`Slide ${index}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {images.map((_, idx) => (
              <div
                key={idx}
                className={`w-1 h-1 rounded-full ${
                  currentIndex === idx ? "bg-white" : "bg-gray-500"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
